import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { chiropracticInfo } from '../models/chriopracticInfo';
import { withNsaTooltip } from './NSATooltip';
const ChiropracticInfoWidget = () => {
    return (_jsx("div", { className: "chiropractic-info-widget", children: chiropracticInfo.map((info) => (_jsxs("div", { children: [_jsx("h2", { children: info.title }), _jsx("p", { children: withNsaTooltip(info.description) }), _jsx("div", { className: "chiropractic-info-infobox", children: _jsx("p", { children: info.infobox }) })] }, info.id))) }));
};
export default ChiropracticInfoWidget;
